/* eslint-disable promise/param-names */
import Vue from 'vue'
import axios from 'axios'
import { AUTH_ERROR, AUTH_LOGOUT, AUTH_REQUEST, AUTH_SUCCESS, AUTH_FORGET_PASSWORD_ERROR, AUTH_FORGET_PASSWORD_REQUEST, AUTH_FORGET_PASSWORD_SUCCESS } from './actiontypes';
import { USER_REQUEST } from '../user/actiontypes';
import authApi from '../../_services/api/authenticate';

const state = {
  token: localStorage.getItem('token') || '',
  status: '',
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
};

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      authApi.login(payload)
        .then((response) => {
          if (response.success === true) {
            localStorage.setItem('token', response.data.token);
            commit(AUTH_SUCCESS, response.data);
            dispatch(USER_REQUEST, response.data.token);
            resolve(response);
          } else {
            commit(AUTH_ERROR, response);
            localStorage.removeItem('token');
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(AUTH_ERROR, error);
          localStorage.removeItem('token');
          reject(error);
        });
    });
  },
  [AUTH_FORGET_PASSWORD_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_FORGET_PASSWORD_REQUEST);
      authApi.forgetPassword(payload)
        .then((response) => {
          if (response.success === true) {
            commit(AUTH_FORGET_PASSWORD_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(AUTH_FORGET_PASSWORD_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(AUTH_FORGET_PASSWORD_ERROR, error);
          reject(error);
        });
    });
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      resolve()
    })
  }
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.token = response.token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [AUTH_FORGET_PASSWORD_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_FORGET_PASSWORD_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [AUTH_FORGET_PASSWORD_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
